import {Button, Tag} from 'platform/components';
import {Box, Heading, HStack, Icon, Show, Text, VStack} from 'platform/foundation';
import {DateTimeFormat} from 'platform/locale';

import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

import {MyDayOrb} from '../../MyDayOrb/MyDayOrb';

interface MyDayHeroProps {
  evaluatedAt?: string;
  isLoading: boolean;
  isPreview?: boolean;
  onRefresh: () => void;
}

export function MyDayHero(props: MyDayHeroProps) {
  return (
    <Box paddingVertical={4}>
      <HStack spacing={4} align="center" justify="space-between" wrap>
        <HStack spacing={3} align="center">
          <MyDayOrb />
          <VStack spacing={1}>
            <Text size="xSmall" color="secondary">
              {i18n.t('aiAssistant.interest.digest.title')}
            </Text>
            <HStack spacing={3} align="center">
              <Heading size={2} headingLevel={1} alternative>
                {i18n.t('page.interestMyDay.header.title')}
              </Heading>
              <Show when={props.isPreview}>
                <Tag
                  label={i18n.t('general.actions.preview')}
                  size="small"
                  colorScheme="purple"
                  isSubtle
                />
              </Show>
            </HStack>
            <Show when={props.evaluatedAt}>
              {(evaluatedAt) => (
                <HStack spacing={2} align="center" wrap>
                  <Icon value="action/schedule" size={3} color="text.tertiary" />
                  <Text size="small" color="secondary">
                    {i18n.t('general.labels.lastUpdated')}
                  </Text>
                  <Text size="small" color="secondary">
                    <DateTimeFormat value={parseDate(evaluatedAt)} format="dateTimeMedium" />
                  </Text>
                </HStack>
              )}
            </Show>
          </VStack>
        </HStack>
        <Button
          variant="outlined"
          leftIcon="navigation/refresh"
          title={i18n.t('general.actions.refresh')}
          aria-label={i18n.t('general.actions.refresh')}
          isLoading={props.isLoading}
          isDisabled={props.isLoading}
          onClick={props.onRefresh}
        />
      </HStack>
    </Box>
  );
}
